module.exports = __webpack_public_path__ + "img/none.43616129.svg";